var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCachedStorage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 12H14m5.3-5.3c-.5-1-.7-1.5-1-1.8a3 3 0 0 0-1.2-.7c-.5-.2-1-.2-2-.2H9c-1.1 0-1.6 0-2.1.2a3 3 0 0 0-1.1.7c-.4.3-.6.8-1.1 1.8L2.5 11l-.3.8-.2.5v2.9c0 1.7 0 2.5.3 3.2.3.5.8 1 1.3 1.3.7.3 1.5.3 3.2.3h10.4c1.7 0 2.5 0 3.2-.3a3 3 0 0 0 1.3-1.3c.3-.7.3-1.5.3-3.2v-.7",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 11.5,
  r: 4.5,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 9.5V12l1 1",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgCachedStorage;